var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({staticClass:"mx-1",attrs:{"color":"primary"},on:{"click":_vm.removeItem}},'v-icon',attrs,false),on),[_vm._v(" mdi-close ")])]}}])},[_c('span',[_vm._v("Remove")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }